import type { TextBlock } from "@prismicio/types-internal/lib/content"
import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import { mergeAttributes } from "@tiptap/core"
import TTParagraph from "@tiptap/extension-paragraph"
import type { Node as ProsemirrorNode, Schema } from "prosemirror-model"

import Text from "../../coreExtensions/Text"
import { converter as TextDirection } from "../../globalExtensions/TextDirection"
import { TextExtension } from "../../models"

const component = TTParagraph.extend({
  name: "paragraph",

  parseHTML() {
    return [
      {
        tag: "p",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "p",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ]
  },
})

const converter = {
  fromPrismic(schema: Schema) {
    return function (paragraph: TextBlock): ProsemirrorNode | undefined {
      const content = Text.converter.fromPrismic(schema)(
        component.name,
        paragraph,
      )
      return schema.nodes[component.name]?.create(
        TextDirection.fromPrismic(paragraph),
        content,
      )
    }
  },

  toPrismic(node: ProsemirrorNode): TextBlock | undefined {
    return Text.converter.toPrismic(
      node,
      RichTextNodeType.paragraph,
      TextDirection.toPrismic(node),
    )
  },
}

const EditorParagraph = new TextExtension(
  [RichTextNodeType.paragraph],
  component.name,
  component,
  converter,
  "Type '/' for commands",
)

// eslint-disable-next-line import/no-default-export
export default EditorParagraph
